<template>
  <div class="item-wrapper">
    <div class="item-header">
      <slot name='header' v-if="$slots.header" />
      <template v-else>
        <span class="item-txt"><BaseTooltip  placement="top" :text="name" :lineNumber="1" /></span>
        <el-tooltip :content="tip" placement="top" v-if="tip">
          <i class="iconfont icon-jieshi-xian"  :content="tip"></i>
        </el-tooltip>
      </template>
    </div>
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: 'SearchItem',
  props: {
    name: String,
    tip: String
  }
}
</script>

<style lang="scss" scoped>
@import '~@/styles/variables.scss';
.item-wrapper {
  display: flex;
  flex-flow: column;
  width: 320px;

  .item-header {
    font-size: 12px;
    height: 12px;
    line-height: 16px;
    font-weight: 400;
    margin-bottom: 8px;
    display: flex;
    align-items: center;
    color: $base-text-primary;
    >.item-txt{
      overflow: hidden;
    }
    >.icon-jieshi-xian{
      color: #8b8e9a;
      margin-left: 4px;
      font-size: 14px;
    }
  }

  /deep/ .el-select {
    width: 100%;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/common/BaseSearchItem.vue